<template>
    <!-- Toolbar Start -->
    <div class="toolbar-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-6 col-12">
                    <div class="toolbar-social">
                        <ul>
                            <li><span class="title">Follow Us On : </span></li>
                            <li><a href="https://m.facebook.com/pages/category/Product-service/Tribinnov-Africa-100261585416357"><i class="lni lni-facebook-original"></i></a></li>
                            <li><a href="https://mobile.twitter.com/tribbinovafrica"><i class="lni lni-twitter-original"></i></a></li>
                            <li><a href="https://www.instagram.com/tribinnov_africa"><i class="lni lni-instagram"></i></a></li>
                            <li><a href="https://linkedin.com/company/tribinnovafrica"><i class="lni lni-linkedin-original"></i></a></li>
                            <li><a href="tribinnovafricaofficial@gmail.com"><i class="lni lni-google"></i></a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-12">
                    <div class="toolbar-login">
                        <div class="button">
                            <a href="https://app.tribinnovafrica.com/register">Create an account</a>
                            <a href="https://app.tribinnovafrica.com/login" class="btn">Login</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Toolbar End -->
</template>

<script>
    export default {
        name: 'Toolbar'
    }
</script>
